module["exports"] = [
  "Cargo Van",
  "Convertible",
  "Coupe",
  "Crew Cab Pickup",
  "Extended Cab Pickup",
  "Hatchback",
  "Minivan",
  "Passenger Van",
  "SUV",
  "Sedan",
  "Wagon"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/vehicle/vehicle_type.js
// module id = 2660
// module chunks = 1610